<template>
  <div class="table-box">
    <el-table
      :data="tableData"
      size="mini"
      ref="table"
      :header-row-style="{ background: '#F8F8F8' }"
      :header-cell-style="{ background: '#F8F8F8' }"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column prop="index" label="序号" width="60"> </el-table-column>
      <el-table-column prop="evidenceCode" label="赋强业务编号" width="150">
        <template slot-scope="scope">
          {{ scope.row.evidenceCode || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="合同名称" width="180">
        <template slot-scope="scope">
          <div class="contract-name">
            <div class="contract-name-text">{{ scope.row.name }}</div>
            <img
              v-if="scope.row.repeated"
              src="../../../../assets/images/index/cf.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="userBizNumber"
        label="合同编号"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="creditAssignee"
        label="委托机构"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>

      <el-table-column
        prop="debtorName"
        label="债务人"
        show-overflow-tooltip
        width="80"
      >
      </el-table-column>
      <el-table-column prop="debtorPhoneMask" label="债务人手机号" width="100">
      </el-table-column>
      <el-table-column
        prop="repayAmount"
        label="还款金额"
        show-overflow-tooltip
        width="90"
      >
      </el-table-column>
      <el-table-column prop="succ" label="业务状态" width="150">
        <template slot-scope="scope">
          <div class="status-box">
            <!-- <div class="dot" :class="{ 'dot-error': !scope.row.succ }"></div>
            <div>{{ scope.row.succ ? "正常" : "异常" }}</div> -->
            {{ scope.row.bizStatus }}

            <el-tooltip
              class="item"
              effect="dark"
              :content="'已拖延' + scope.row.blzDays + '天'"
              placement="top"
              v-if="scope.row.blzDays >= 3 && scope.row.bizStatus === '办理中'"
            >
              <span
                class="blz-tag"
                :class="scope.row.blzDays >= 7 ? 'blz-7' : ''"
                >{{ scope.row.blzDays >= 7 ? 7 : 3 }}天+</span
              >
            </el-tooltip>
            <div style="flex: 1; margin-left: 4px">
              <el-progress
                v-if="scope.row.bizStatus === '办理中'"
                :text-color="
                  scope.row.applyProgressRatio > 0 ? '#ffffff' : '#000000'
                "
                :text-inside="true"
                :stroke-width="16"
                :percentage="scope.row.applyProgressRatio"
              ></el-progress>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="round"
        label="业务来源"
        show-overflow-tooltip
        width="180"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.round === "手动创建"
                ? "手动创建"
                : scope.row.round + "批量"
            }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="businessDynamics" label="业务动态" width="280">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="certificateDate" label="出证时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.certificateDate || "-" }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="round" label="导入批次" width="100">
        </el-table-column> -->
      <!-- <el-table-column prop="createTime" label="导入时间" width="180">
        </el-table-column> -->
      <!-- <el-table-column
        prop="comment"
        show-overflow-tooltip
        label="合同备注"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="导入数据备注"
        show-overflow-tooltip
        min-width="200px"
      >
      </el-table-column> -->
      <el-table-column prop="date" label="操作" width="190" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            class="red-button"
            @click="onDetail(scope.row)"
            >详情</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="red-button"
            @click="tipPerson(scope.row)"
            :disabled="scope.row.remindDisabled"
            v-if="scope.row.remind"
          >
            <span v-if="!scope.row.remindDisabled">提醒</span>
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              :content="
                scope.row.remindDisabledTime
                  ? scope.row.remindDisabledTime + '内 无法再次提醒'
                  : ''
              "
              placement="top"
            >
              <span>
                提醒
                <i class="el-icon-time"></i>
              </span>
            </el-tooltip>
          </el-button>
          <el-button
            type="text"
            size="mini"
            class="red-button"
            @click="onPrioritize(scope.row)"
            :disabled="scope.row.priority"
            v-if="scope.row.bizStatus === '审核中'"
          >
            {{ scope.row.priority ? "已加急" : "加急" }}
          </el-button>
          <el-button
            type="text"
            size="mini"
            class="red-button"
            @click="onDownLoad(scope.row)"
            v-if="scope.row.bizStatus === '审核中' || scope.row.bizStatus === '已出证'"
          >
            下载合同
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
              
<script>
import BaseApi from "@lib/baseApi.js";

export default {
  name: "table",
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  components: {},

  data() {
    return {
      tableData: [],
      total: 0,
    };
  },

  created() {},
  mounted() {},

  methods: {
    // 加急
    onPrioritize(item) {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/notaryApply/prioritize", {
        id: item.id,
        priority: 1,
      }).then(
        (data) => {
          this.$store.commit("showLoading", false);
          if (data.code == 200) {
            this.$message.success("操作成功");
            this.$emit("reload");
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
    },

    // 提醒
    tipPerson(row) {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/contract/remind", {
        id: row.id,
      })
        .then((data) => {
          this.$store.commit("showLoading", false);
          if (data.datas.success) {
            this.$message.success("已发送提醒");
            this.$emit("reload");
          } else {
            this.$message.error("提醒发送失败");
          }
        })
        .catch((e) => {
          this.$store.commit("showLoading", false);
          errorLog(e);
        });
    },

    // 详情
    onDetail(row) {
      this.$router.push({
        path: "/personal/businessDetail",
        query: {
          id: row.id,
          businessDynamics: row.businessDynamics,
        },
      });
    },

    onDownLoad(row) {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/file/download", { id: row.id })
        .then((data) => {
          this.$store.commit("showLoading", false);
          if (data.datas.zipUrl) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.setAttribute("id", "startDown");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
            } catch (e) {}
            // window.open(data.datas.zipUrl);
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
          this.$store.commit("showLoading", false);
        });
    },
  },
};
</script>
              
<style scoped lang='scss'>
.table-box {
  padding: 10px;
}

.status-box {
  display: flex;
  align-items: center;
}

.blz-tag {
  font-size: 12px;
  font-weight: bold;
  color: #ffa940;
  margin-left: 4px;
  &.blz-7 {
    color: #db1c1b;
  }
}
</style>
              